export default __webpack_public_path__ + "static/media/bubble-mint-now.ed5086d9.svg";